export default "__VITE_ASSET__mnsndxUN__"